import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { RadioRatingField } from "../../components/Forms";
import { Icon } from "../../components/Icon";
import { useMsg } from "../../components/Msg/Msg";
import { H2 } from "../../components/Typography";
import { gray500, gray900 } from "../../theme";
import { useMyMutation } from "../Authorization/AuthProvider";
import { QueryRenderer } from "../QM/QueryRenderer";
import { sessionsMessages } from "./messages";

const Rating = ({ label, name, minLabel, maxLabel }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" mb={1}>
        {label}
      </Typography>
      <RadioRatingField
        name={name}
        options={Array(10)
          .fill(null)
          .map((_, i) => ({ label: i + 1, value: i + 1 }))}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
        }}
      >
        <Typography variant="body2">{minLabel}</Typography>
        <Typography variant="body2">{maxLabel}</Typography>
      </Box>
    </Box>
  );
};

const useEvaluationMutation = ({ onSuccess }) => {
  return useMyMutation({
    fetchDef: {
      url: `/api/latest/user-sessions/feedback`, // upravená URL podle tvého API
      method: "POST",
    },
    onSuccess,
  });
};

const EVALUATION_QUESTION_KEY = {
  satisfaction_with_lessons: "satisfaction_with_lessons",
  contribution_to_personal_growth: "contribution_to_personal_growth",
  clarity_about_the_next_steps: "clarity_about_the_next_steps",
};

const getQuestionTranslations = (msg, key) => ({
  label: msg(`dict.evaluation.questions.${key}.label`),
  minLabel: msg(`dict.evaluation.questions.${key}.minLabel`),
  maxLabel: msg(`dict.evaluation.questions.${key}.maxLabel`),
});

export const EvaluationModal = ({ onClose, open }) => {
  const msg = useMsg({ dict: sessionsMessages });
  const mutation = useEvaluationMutation({ onSuccess: onClose });
  const methods = useForm({
    mode: "onSubmit",
    // values: query.data,
  });
  const onSubmit = (values) => {
    return mutation.mutateAsync(values);
  };
  const onError = (errors, e) => console.log("[modal.onError]", errors, e);

  console.log("[EvaluationModal.rndr]", {
    mutation,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="evaluation-modal-title"
      aria-describedby="evaluation-modal-description"
    >
      <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "80%", md: "800px" },
            bgcolor: "background.paper",
            borderRadius: "6px",
            p: { xs: 3, md: 3 },
            display: "flex",
            flexDirection: "column",
            gap: 3,
            maxHeight: "90vh",
            overflow: "auto",
            // border: "2px solid #000",
            // boxShadow: 24,
          }}
        >
          <FormProvider {...methods}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Avatar sx={{ bgcolor: "#F9FAFB", width: 48, height: 48 }}>
                <Avatar sx={{ bgcolor: "#EAECF0", width: 36, height: 36 }}>
                  <Icon
                    name="ChatBubbleOutlineOutlined"
                    sx={{ color: gray500 }}
                  />
                </Avatar>
              </Avatar>
              <IconButton onClick={onClose}>
                <Icon name="Close" sx={{ color: gray500 }} />
              </IconButton>
            </Box>
            <QueryRenderer query={mutation} success={null} loading={null} />
            <H2 id="evaluation-modal-title">{msg("evaluation.modal.title")}</H2>
            <Box
              sx={{
                width: "80%",
                display: "flex",
                mx: "15px",
                p: "24px",
                justifyContent: "center",
                alignContent: "center",
                flexDirection: "column",
              }}
            >
              {[
                EVALUATION_QUESTION_KEY.satisfaction_with_lessons,
                EVALUATION_QUESTION_KEY.contribution_to_personal_growth,
                EVALUATION_QUESTION_KEY.clarity_about_the_next_steps,
              ].map((questionKey) => (
                <Rating
                  key={questionKey}
                  name={`answers.${questionKey}`}
                  {...getQuestionTranslations(msg, questionKey)}
                />
              ))}
            </Box>
            <Controller
              name="feedback"
              control={methods.control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  placeholder={msg("evaluation.modal.textfield.placeholder")}
                  multiline
                  inputProps={{ maxLength: 1000 }}
                  rows={5}
                  sx={{ color: gray900 }}
                />
              )}
            />
            <Divider flexItem sx={{ mt: 3 }} />
            <Box display="flex" flexDirection="row" gap={3}>
              <Button fullWidth variant="outlined" onClick={() => onClose()}>
                {msg("evaluation.modal.skip")}
              </Button>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                disabled={mutation.isLoading}
              >
                {msg("evaluation.modal.share")}
              </Button>
            </Box>
          </FormProvider>
        </Paper>
      </form>
    </Modal>
  );
};
